import { useZero } from "@rocicorp/zero/react";
import { useCallback, useState } from "react";
import { sharedMutators } from "../../shared/mutators";

export type MoveRequest = {
  workflowId: string;
  targetSpaceId: string;
  targetSpaceName: string;
};

export function useMoveWorkflow(): {
  requestMove: (args: MoveRequest) => void;
  pending: MoveRequest | null;
  confirmMove: () => void;
  cancelMove: () => void;
} {
  const z = useZero();
  const [pending, setPending] = useState<MoveRequest | null>(null);

  const requestMove = useCallback((args: MoveRequest) => {
    setPending(args);
  }, []);

  const confirmMove = useCallback(() => {
    if (!pending) return;
    z.mutate(
      sharedMutators.moveWorkflow({
        workflowId: pending.workflowId,
        spaceId: pending.targetSpaceId,
      })
    );
    setPending(null);
  }, [pending, z]);

  const cancelMove = useCallback(() => {
    setPending(null);
  }, []);

  return {
    requestMove,
    pending,
    confirmMove,
    cancelMove,
  };
}
